import { profJimBrandColors } from "../../theme/variants";

export const promptEngineeringPlaygroundClientId = {
  general: "1",
  boston: "2",
  k12Coalition: "3",
};

export const promptEngineeringPlaygroundColorConfig = {
  "1": {
    headerColor: profJimBrandColors.grey,
    instructionColor: profJimBrandColors.grey,
    previewbackgroundColor: profJimBrandColors.purple,
    buttonColor: profJimBrandColors.purple,
    urlButtonColor: profJimBrandColors.orange,
    primaryFont: "Poppins",
  },
  "2": {
    headerColor: "#307957",
    instructionColor: "#4BB976",
    previewbackgroundColor: "#307957",
    buttonColor: "#307957",
    primaryFont: "Henderson",
  },
};

// #00BEA8
